module.exports = __webpack_public_path__ + "img/img21.f8cc1677.png";